import React, { useEffect, useState } from "react";
import { CKEditor } from "ckeditor4-react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useFormik } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Minus } from "react-feather";
import PostApiCall from "../../Api/Api";
import GetApiCall from "../../Api/GetApi";
import BreadCrumb from "../../Components/BreadCrumbComp";
import { useNavigate, useLocation } from "react-router-dom";
import { delay } from "../../Helper/ToastDelay";
import Notiflix, { Report } from "notiflix";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { toast } from "react-toastify";
import moment from "moment";
import { getCurrentDate } from "../../Utils";
import { generateCustomStyles } from "../../Helper/CustomStyleError";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("Job Title is required"),
  // area: Yup.string().required("Functional area is required"),
  // category: Yup.string().required("Category is required"),
  type: Yup.object().shape({
    value: Yup.string().required("Job type is required"),
  }),

  // employeremail: Yup.string()
  //   .email("Invalid email")
  //   .required("Email is required"),

  jobdescription: Yup.string().required("Job description is required"),
  // duties: Yup.string().required("Duties is required"),
  // skillset: Yup.string().required("Skill set is required"),

  country: Yup.object().shape({
    value: Yup.string().required("Country is required"),
  }),

  city: Yup.object().shape({
    value: Yup.string().required("City is required"),
  }),
  state: Yup.object().shape({
    value: Yup.string().required("State is required"),
  }),
  pincode: Yup.string()
    .notRequired("Pincode is required")
    .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits

  // experience: Yup.string().notRequired(),
  // company: Yup.string().required("Company is required"),
  // employername: Yup.string().required("Employer name is required"),
  // employerdesignation: Yup.string().required(
  //   "Employer Degisnation is required"
  // ),
  // employeremail: Yup.string().required("Employee Email is required"),
  closingdate: Yup.string().required("Closing date is required"),

  openingdate: Yup.string().required("Opening date is required"),
  auditdate: Yup.string().required("Audit date is required"),
  auditenddate: Yup.string().required("Audit End date is required"),

  // auditenddate: Yup.string().when('auditenddatetype', (auditenddatetype, schema) => 
  //   auditenddatetype == 'No' 
  //     ? schema.required('Audit End date is required') 
  //     : schema.notRequired()
  // ),
  // address: Yup.string().required("Address date is required"),
  positions: Yup.string().required("Position date is required"),

  // employermobile: Yup.string()
  //   .required("Contact Number is required")
  //   .matches(/^[0-9]{10}$/, "Invalid Contact Number"),
});

const ViewPublishJob = () => {
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const history = useNavigate();
  const location = useLocation();
  const [jobDetail, setJobDetails] = useState(location?.state || {});
  const [isEditable, setIsEditable] = useState(true);

  console.log("jobDetail", jobDetail);

  const jobType = [
    { value: "Full time", label: "Full time" },
    { value: "Part time", label: "Part time" },
    { value: "Contractual", label: "Contractual" },
  ];
  const SalaryType = [
    { value: "Per Hour", label: "Per Hour" },
    { value: "Per Day", label: "Per Day" },
    { value: "Per Week", label: "Per Week" },
    { value: "Per Month", label: "Per Month" },
  ];
  const expType = [
    { value: "Years", label: "Years" },
    { value: "Months", label: "Months" },
  ];
  const Allqualification = [
    { value: "10th", label: "10th" },
    { value: "12th", label: "12th" },
    { value: "Diploma", label: "Diploma" },
    { value: "Graduation", label: "Graduation" },
    { value: "Post Graduation", label: "Post Graduation" },
    { value: "CA/CS/CMA Foundation", label: "CA/CS/CMA Foundation" },
    { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
    { value: "CA/CS/CMA Finalist", label: "CA/CS/CMA Finalist" },
    { value: "CA/CS/CMA", label: "CA/CS/CMA" },
  ];

  const formik = useFormik({
    initialValues: {
      title: jobDetail.fld_title || "",
      type: jobDetail.fld_type ? { value: jobDetail.fld_type, label: jobDetail.fld_type } : null,

      category: jobDetail.fld_category || "",
      area: jobDetail.fld_area
        ? jobDetail.fld_area.split(",").map((value) => ({
          label: value,
          value: value,
        }))
        : [],
      projectcoordinatoremail: jobDetail.fld_projectcoordinatoremail
        ? jobDetail.fld_projectcoordinatoremail.split(",").map((value) => ({
          label: value,
          value: value,
        }))
        : [],
      projectcoordinatorname: jobDetail?.fld_projectcoordinatorname || "",
      qualification: jobDetail?.fld_qualification
        ? {
            label: jobDetail?.fld_qualification,
            value: jobDetail?.fld_qualification,
          }
        : null,

      AssignmentDuration: jobDetail?.fld_assignduration || "",
      Laptop: jobDetail?.fld_laptop || "",
      Vehicle: jobDetail?.fld_vehicle || "",

      address: jobDetail?.fld_address || "",
      country: jobDetail?.fld_country
        ? {
            label: jobDetail.fld_country,
            value: jobDetail.fld_country,
          }
        : { value: 101, label: "India" },
      state: jobDetail?.fld_state
        ? { label: jobDetail?.fld_state, value: jobDetail?.fld_state }
        : null,
      city: jobDetail?.fld_city ? { label: jobDetail.fld_city, value: jobDetail.fld_city } : null,
      pincode: jobDetail.fld_pincode || "",
      jobdescription: jobDetail.fld_jobdescription || "",
      duties: jobDetail.fld_duties || "",
      skillset: jobDetail.fld_skillset || "",
      experience: jobDetail.fld_experience || "",
      company: jobDetail.fld_company || "",
      employername: jobDetail.fld_employername || "",
      employerdesignation: jobDetail.fld_employerdesignation || "",
      employeremail: jobDetail.fld_employeremail || "",
      employermobile: jobDetail.fld_employermobile || "",
      minsalary: jobDetail.fld_minsalary ?? "",
      maxsalary: jobDetail.fld_maxsalary ?? "",
      salarytype: jobDetail.fld_salarytype ? { label: jobDetail.fld_salarytype, value: jobDetail.fld_salarytype } : null,
      minexperience: jobDetail.fld_minexperience ?? "",
      maxexperience: jobDetail.fld_maxexperience ?? "",
      experiencetype: jobDetail.fld_experiencetype ? { label: jobDetail.fld_experiencetype, value: jobDetail.fld_experiencetype } : null,
      positions: jobDetail.fld_positions ?? "",
      remotework: jobDetail.fld_remotework || "",
      closingdate: jobDetail.fld_closingdate || "",

      openingdate: jobDetail.fld_openingdate || "",
      auditdate: jobDetail.fld_auditdate || "",
      auditenddate: jobDetail.fld_auditenddate || "",
      auditenddatetype: jobDetail.fld_auditenddatetype || "No",

      status: jobDetail.fld_status || "",
      approved: jobDetail.fld_approved || "",
    },
    validationSchema: validationSchema,
    validateOnBlur: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        Notiflix.Loading.standard();
        const payload = {
          id: jobDetail.fld_id,
          title: values.title,
          type: values.type?.value,
          category: values.category,
          // area: values.area,
          qualification: values?.qualification?.label ?? "",
          address: values.address || "",
          assignduration: values.AssignmentDuration || "",
          laptop: values.Laptop || "",
          vehicle: values.Vehicle || "",

          country: values.country.label,
          state: values.state.label,
          city: values.city.label,
          pincode: values.pincode,
          jobdescription: values.jobdescription,

          skillset: values.skillset,
          experience: values.experience,
          company: values.company || "",
          employername: values.employername,
          employerdesignation: values.employerdesignation,
          employeremail: values.employeremail,
          employermobile: values.employermobile,
          minsalary: values.minsalary,
          maxsalary: values.maxsalary,
          salarytype: values.salarytype?.value,
          minexperience: values.minexperience,
          maxexperience: values.maxexperience || null,
          experiencetype: values.experiencetype?.value,
          positions: values.positions,
          remotework: values.remotework,
          closingdate: values.closingdate,
          openingdate: values.openingdate,
          status: values.status,
          approved: values.approved,
          auditdate: values.auditdate,
          auditenddate: values.auditenddate,
          auditenddatetype: values.auditenddatetype,

          projectcoordinatorname: values.projectcoordinatorname,
        };
        let cityArr = await values.area
          .map((ele) => ele.value.trim())
          .join(",");
        payload.area = cityArr;
        let emailArr = await values?.projectcoordinatoremail
          .map((ele) => ele.value.trim())
          .join(",");
        payload.projectcoordinatoremail = emailArr;

        const res = await PostApiCall.postRequest(payload, "UpdateJobOpening");
        if (res.status === 200 || res.status === 201) {
          Notiflix.Loading.remove();
          // toast.success("Updated Successfully", {
          //   autoClose: delay,
          // });
          Report.success(
            `Updated Succesfully`,
            // '"Do not try to become a person of success but try to become a person of value." <br/><br/>- Albert Einstein',
            "",
            "Okay"
          );

          history("/publish-job");
        } else {
          toast.error(SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });
          Notiflix.Loading.remove();
        }
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    },
  });

  const submitHandler = () => {
    formik.handleSubmit();
    setTimeout(() => {
      if (Object.keys(formik.errors).length > 0) {
        // Show toast for the first error message
        const firstErrorKey = Object.keys(formik.errors)[0];
        toast.error(formik.errors[firstErrorKey], { autoClose: 3000 });
      }
    }, 100);
    window.scroll(0, 0);
  };

  useEffect(() => {
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);
          // Notiflix.Loading.remove()
        })
      );
    };

    getCountry();
  }, [formik.values.country.value]);

  useEffect(() => {
    const getState = () => {
      if (!formik.values.country?.value) return;
      const filterState = allCountry?.find(
        (i) => i?.label == formik.values?.country?.label
      );
      PostApiCall.postRequest(
        { countryid: filterState?.value },
        "GetState"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllState(obj?.data);
          const currentState = obj?.data?.find(
            (state) => state?.label === formik.values?.state?.label
          );
          // formik.setFieldValue("state", currentState);
          // formik.setFieldValue("state", null);
          // Notiflix.Loading.remove()
        })
      );
    };
    getState();
  }, [formik.values.country, allCountry]);

  useEffect(() => {
    const getCity = () => {
      const filterCity = allState?.find(
        (i) => i?.label == formik.values?.state?.label
      );
      PostApiCall.postRequest({ stateid: filterCity?.value }, "GetCity").then(
        (resultdes) =>
          resultdes.json().then((obj) => {
            const cities = obj?.data || [];
            setAllCity(cities);
            if (cities.length < 0) {
              formik.setFieldValue("city", { value: "none", label: "None" });
            }
            // Notiflix.Loading.remove()
          })
      );
    };
    getCity();
  }, [formik.values.state, allState]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const updateApprovalStatus = () => {
    const payload = { approved: "Yes", jobid: jobDetail.fld_id };
    PostApiCall.postRequest(payload, "UpdateJobApprovalStatus").then(
      (results1) =>
        results1.json().then((obj1) => {
          if (results1.status === 200 || results1.status === 201) {
            toast.success("Job Opening has been successfully approved", {
              autoClose: delay,
            });
          }
        })
    );
    history("/publish-job");
  };

  const handleJobDescriptionReady = (evt) => {
    try {
      const data = formik.values.jobdescription || "";
      if (data) evt.editor.setData(data);
    } catch (e) {
      // ignore
    }
  };

  const handleSkillsetReady = (evt) => {
    try {
      const data = formik.values.skillset || "";
      if (data) evt.editor.setData(data);
    } catch (e) {
      // ignore
    }
  };
  return (
    <section className="section mx-3  px-md-4">
      {/* breadcrumb */}
      <div className="container">
        <div className="w-100 mt-5">
          <BreadCrumb icon={false} subitem={"View Publish Job"} />
        </div>
        <FormGroup>
          <Card
            className="my-3 border-0"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <CardBody>
              {!isEditable && (
                <button className="btns" onClick={() => setIsEditable(true)}>
                  Edit Details
                </button>
              )}
              <button
                type="reset"
                className="cancelBtn ml-2"
                style={{ marginRight: "10px" }}
                onClick={() => {
                  setIsEditable(false);
                  history("/publish-job");
                }}
              >
                Back
              </button>
              {jobDetail.fld_approved !== "Yes" && (
                <button
                  className="btnsborder my-md-auto my-2"
                  style={{ marginRight: "10px" }}
                  onClick={updateApprovalStatus}
                >
                  Approve Opening
                </button>
              )}
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Basic Information</p>
            <CardBody>
              <div>
                <Row>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Job Title<span className="mandatory">*</span>
                      </Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="title"
                        id="nameVertical"
                        placeholder="Job title"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.title}
                      />
                      {formik.touched.title && formik.errors.title && (
                        <div className="error text-danger pl-2">
                          {formik.errors.title}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        Job Type<span className="mandatory">*</span>
                      </Label>

                      <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="type"
                        value={formik.values.type}
                        onBlur={formik.handleBlur}
                        disabled={!isEditable}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("type", selectedOption)
                        }
                        options={jobType}
                      />

                      {formik.touched.type && formik.errors.type && (
                        <div className="error text-danger pl-2">
                          {formik.errors.type.value}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Industry Type</Label>
                      <Input
                        type="text"
                        name="category"
                        id="nameVertical"
                        disabled={!isEditable}
                        placeholder="Industry Type"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.category}
                        invalid={
                          formik.touched.category && !!formik.errors.category
                        }
                      />
                      {formik.touched.category && formik.errors.category && (
                        <FormFeedback>{formik.errors.category}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">Minimum Qualification</Label>

                      <Select
                        className={`React ${formik.touched.qualification &&
                          formik.errors.qualification
                          ? "is-invalid"
                          : ""
                          }`}
                        isDisabled={!isEditable}
                        classNamePrefix="select"
                        onBlur={formik.handleBlur}
                        name="qualification"
                        value={formik.values.qualification}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("qualification", selectedOption)
                        }
                        options={Allqualification}
                        styles={generateCustomStyles("qualification", formik)}
                      />

                      {formik.touched.qualification &&
                        formik.errors.qualification && (
                          <FormFeedback>
                            {formik.errors.qualification.value}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Client Name</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="company"
                        onBlur={formik.handleBlur}
                        id="nameVertical"
                        placeholder="Client Name"
                        onChange={formik.handleChange}
                        value={formik.values.company}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Project Coordinator </Label>
                      <Input
                        type="text"
                        disabled={!isEditable}
                        name="projectcoordinatorname"
                        id="nameVertical"
                        placeholder="Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.projectcoordinatorname}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Project Coordinator Email
                      </Label>

                      <CreatableSelect
                        isClearable
                        className={`React ${formik.touched.projectcoordinatoremail &&
                          formik.errors.projectcoordinatoremail
                          ? "is-invalid"
                          : ""
                          }`}
                        classNamePrefix="Enter Email"
                        name="projectcoordinatoremail"
                        isMulti
                        isDisabled={!isEditable}
                        placeholder="Enter Email"
                        noOptionsMessage={() =>
                          "Type to create new Enter Email"
                        }
                        onChange={(selectedOption) =>
                          formik.setFieldValue(
                            "projectcoordinatoremail",
                            selectedOption
                          )
                        }
                        value={formik.values.projectcoordinatoremail}
                        onBlur={formik.handleBlur}
                        styles={generateCustomStyles(
                          "projectcoordinatoremail",
                          formik
                        )}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Job Location</p>
            <CardBody>
              <div>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Address
                        {/* <span className="mandatory">*</span> */}
                      </Label>
                      <Input
                        type="textarea"
                        disabled={!isEditable}
                        className="p-3"
                        name="address"
                        placeholder="Enter your address"
                        // id="nameVertical"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                        maxLength={400}
                      />
                      <div
                        className="text-end text-muted mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        {formik.values?.address?.length}/400
                      </div>
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        Country<span className="mandatory">*</span>
                      </Label>
                      <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="country"
                        onChange={(selectedOption) => {
                          formik.setFieldValue("country", selectedOption);
                          formik.setFieldValue("state", "");
                          formik.setFieldValue("city", "");
                          // PostApiCall.postRequest(
                          //   { countryid: selectedOption?.value },
                          //   "GetState"
                          // ).then((resultdes) =>
                          //   resultdes.json().then((obj) => {
                          //     setAllState(obj?.data);
                          //     // Notiflix.Loading.remove()
                          //   })
                          // );
                        }}
                        options={allCountry}
                        value={formik.values.country}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.country && formik.errors.country && (
                        <div className="error text-danger pl-2">
                          {formik.errors.country.value}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        State<span className="mandatory">*</span>
                      </Label>
                      <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="state"
                        onChange={(selectedOption) => {
                          formik.setFieldValue("state", selectedOption);
                          formik.setFieldValue("city", "");
                          // PostApiCall.postRequest(
                          //   { stateid: selectedOption?.value },
                          //   "GetCity"
                          // ).then((resultdes) =>
                          //   resultdes.json().then((obj) => {
                          //     setAllCity(obj?.data);
                          //     // Notiflix.Loading.remove()
                          //   })
                          // );
                        }}
                        value={formik.values.state}
                        onBlur={formik.handleBlur}
                        options={allState}
                      />
                      {formik.touched.state && formik.errors.state && (
                        <div className="error text-danger pl-2">
                          {formik.errors.state.value}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        City<span className="mandatory">*</span>
                      </Label>
                      <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="city"
                        onChange={(selectedOption) =>
                          formik.setFieldValue("city", selectedOption)
                        }
                        options={allCity}
                        value={formik.values.city}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.city && formik.errors.city && (
                        <div className="error text-danger pl-2">
                          {formik.errors.city.value}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Areas</Label>
                      <CreatableSelect
                        isClearable
                        className={`React ${formik.touched.area && formik.errors.area
                          ? "is-invalid"
                          : ""
                          }`}
                        classNamePrefix="Select.."
                        name="area"
                        isDisabled={!isEditable}
                        isMulti
                        placeholder="Enter.."
                        noOptionsMessage={() => "Type to create new city name"}
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("area", selectedOption)
                        }
                        value={formik.values.area}
                        styles={generateCustomStyles("area", formik)}
                      />
                      {formik.touched.area && formik.errors.area && (
                        <FormFeedback>{formik.errors.area}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Pincode</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="pincode"
                        id="nameVertical"
                        placeholder="Enter your Pincode"
                        onChange={formik.handleChange}
                        value={formik.values.pincode}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.pincode && formik.errors.pincode && (
                        <div className="error text-danger pl-2">
                          {formik.errors.pincode}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          {/* <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Employer Information</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Company Name<span className="mandatory">*</span>
                      </Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="company"
                        id="nameVertical"
                        placeholder="Company Name"
                        onChange={formik.handleChange}
                        value={formik.values.company}
                      />
                      {formik.touched.company && formik.errors.company && (
                        <div className="error text-danger pl-2">
                          {formik.errors.company}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">Employer Name</Label>

                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="employername"
                        id="nameVertical"
                        placeholder="Name"
                        onChange={formik.handleChange}
                        value={formik.values.employername}
                      />
                      {formik.touched.employername &&
                        formik.errors.employername && (
                          <div className="error text-danger pl-2">
                            {formik.errors.employername}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Employer Designation</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="employerdesignation"
                        id="nameVertical"
                        placeholder="Designation"
                        onChange={formik.handleChange}
                        value={formik.values.employerdesignation}
                      />
                      {formik.touched.employerdesignation &&
                        formik.errors.employerdesignation && (
                          <div className="error text-danger pl-2">
                            {formik.errors.employerdesignation}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Employer Email</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="employeremail"
                        id="nameVertical"
                        placeholder="Email"
                        onChange={formik.handleChange}
                        value={formik.values.employeremail}
                      />
                      {formik.touched.employeremail &&
                        formik.errors.employeremail && (
                          <div className="error text-danger pl-2">
                            {formik.errors.employeremail}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Employer Mobile</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="employermobile"
                        id="nameVertical"
                        placeholder="Mobile"
                        onChange={formik.handleChange}
                        value={formik.values.employermobile}
                      />
                      {formik.touched.employermobile &&
                        formik.errors.employermobile && (
                          <div className="error text-danger pl-2">
                            {formik.errors.employermobile}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card> */}

          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Job Description</p>
            <CardBody>
              <Form>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <CKEditor
                        config={{
                          extraPlugins: "justify,font,colorbutton,image2",
                          removePlugins: "image",
                          height: "300px",
                        }}
                        isDisabled={!isEditable}
                        readOnly={!isEditable}
                        data={formik.values.jobdescription}
                        onInstanceReady={handleJobDescriptionReady}
                        name={"jobdescription"}
                        onChange={(event) => {
                          formik.setFieldValue(
                            "jobdescription",
                            event.editor.getData()
                          );
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col sm="12">
                    <FormGroup>
                      <p className="my-3 headingStyle">General Description</p>
                      <CKEditor
                        config={{
                          extraPlugins: "justify,font,colorbutton,image2",
                          removePlugins: "image",
                          height: "300px",
                        }}
                        isDisabled={!isEditable}
                        readOnly={!isEditable}
                        data={formik.values.skillset}
                        onInstanceReady={handleSkillsetReady}
                        name={"skillset"}
                        onChange={(event) => {
                          formik.setFieldValue(
                            "skillset",
                            event.editor.getData()
                          );
                        }}
                      />
                    </FormGroup>
                  </Col>

                  {/* <Col sm="12">
                  <FormGroup>
                    <p className="my-3 headingStyle">
                      Educational and Other details
                    </p>

                    <CKEditor
                      config={{
                        extraPlugins: "justify,font,colorbutton,image2",
                        height: "200px",
                      }}
                      isDisabled={!isEditable}
                      readOnly={!isEditable}
                      data={formik.values.experience}
                      name={"experience"}
                      onChange={(event) => {
                        formik.setFieldValue(
                          "experience",
                          event.editor.getData()
                        );
                      }}
                    />
                  </FormGroup>
                </Col> */}
                </Row>
              </Form>
            </CardBody>
          </Card>

          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Salary & Experience</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Min Salary</Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="minsalary"
                        id="nameVertical"
                        placeholder="Minimum Salary"
                        onChange={formik.handleChange}
                        value={formik.values.minsalary}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.minsalary && formik.errors.minsalary && (
                        <div className="error text-danger pl-2">
                          {formik.errors.minsalary}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="1" className="align-self-center">
                    <div className="text-center">
                      <Minus />
                    </div>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="">Max Salary</Label>

                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="maxsalary"
                        id="nameVertical"
                        placeholder="Maximum Salary"
                        onChange={formik.handleChange}
                        value={formik.values.maxsalary}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.maxsalary && formik.errors.maxsalary && (
                        <div className="error text-danger pl-2">
                          {formik.errors.maxsalary}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="3">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Salary Type</Label>
                      {/* <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="salarytype"
                        onChange={(selectedOption) =>
                          formik.setFieldValue("salarytype", selectedOption)
                        }
                        value={formik.values.salarytype}
                        options={SalaryType}
                      /> */}
                      <CreatableSelect
                        isDisabled={!isEditable}
                        isClearable
                        className={`React ${formik.touched.salarytype && formik.errors.salarytype
                          ? "is-invalid"
                          : ""
                          }`}
                        classNamePrefix="Select.."
                        name="salarytype"
                        options={SalaryType}
                        placeholder="Select.."
                        noOptionsMessage={() => "Select"}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("salarytype", selectedOption)
                        }
                        value={formik.values.salarytype}
                        onBlur={formik.handleBlur}
                        styles={generateCustomStyles("salarytype", formik)}
                      />
                      {formik.touched.salarytype &&
                        formik.errors.salarytype && (
                          <div className="error text-danger pl-2">
                            {formik.errors.salarytype}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Min Experience<span className="mandatory">*</span>
                      </Label>
                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="minexperience"
                        id="nameVertical"
                        placeholder="Minimum Experience"
                        onChange={formik.handleChange}
                        value={formik.values.minexperience}
                        onBlur={formik.handleBlur}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="1" className="align-self-center">
                    <div className="text-center">
                      <Minus />
                    </div>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="">Max Experience</Label>

                      <Input
                        disabled={!isEditable}
                        type="text"
                        name="maxexperience"
                        id="nameVertical"
                        placeholder="Maximum Experience"
                        onChange={formik.handleChange}
                        value={formik.values.maxexperience}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.maxexperience &&
                        formik.errors.maxexperience && (
                          <div className="error text-danger pl-2">
                            {formik.errors.maxexperience}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="3">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Experience Type<span className="mandatory">*</span>
                      </Label>
                      <Select
                        isDisabled={!isEditable}
                        className="React"
                        classNamePrefix="select"
                        name="experiencetype"
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("experiencetype", selectedOption)
                        }
                        value={formik.values.experiencetype}
                        options={expType}
                      />
                      {formik.touched.experiencetype &&
                        formik.errors.experiencetype && (
                          <div className="error text-danger pl-2">
                            {formik.errors.experiencetype}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Audit Duration</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Audit Start Date<span className="mandatory">*</span>
                      </Label>
                      {/* <Input
                        disabled={!isEditable}
                        type="date"
                        name="openingdate"
                        id="nameVertical"
                        placeholder="Opening Date"
                        // defaultValue={0}
                        onChange={formik.handleChange}
                        value={formik.values.openingdate}
                        min={getCurrentDate()}
                      /> */}
                      <Flatpickr
                        value={formik.values.auditdate}
                        className={`form-control ${formik.touched.auditdate && formik.errors.auditdate
                          ? "is-invalid"
                          : ""
                          } ${formik.touched.auditdate && formik.errors.auditdate
                            ? "invalid-border"
                            : ""
                          }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("auditdate", formik)}
                        name="auditdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "auditdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format(
                              "YYYY-MM-DD"
                            );
                            formik.setFieldValue("auditdate", formattedDate);
                          } else {
                            formik.setFieldValue("auditdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.auditdate && formik.errors.auditdate && (
                        <div className="error text-danger pl-2">
                          {formik.errors.auditdate}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Audit End Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        value={formik.values.auditenddate}
                        className={`form-control ${formik.touched.auditenddate &&
                          formik.errors.auditenddate
                          ? "is-invalid"
                          : ""
                          } ${formik.touched.auditenddate &&
                            formik.errors.auditenddate
                            ? "invalid-border"
                            : ""
                          }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("auditenddate", formik)}
                        name="auditenddate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "auditenddate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format(
                              "YYYY-MM-DD"
                            );
                            formik.setFieldValue(
                              "auditenddate",
                              formattedDate
                            );
                          } else {
                            formik.setFieldValue("auditenddate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.auditenddate &&
                        formik.errors.auditenddate && (
                          <FormFeedback>
                            {formik.errors.auditenddate}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>


                  <Col sm="4">
                    <div className="text-center">
                      <Label htmlFor="nameVertical">
                        Is the Audit date fixed ?
                        <span className="mandatory">*</span>
                      </Label>
                      <div
                        className={`d-flex justify-content-center ${formik.touched.auditenddatetype &&
                          formik.errors.auditenddatetype
                          ? "radio-error"
                          : ""
                          }`}
                      >
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="auditenddatetype"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("auditenddatetype", "Yes")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.auditenddatetype === "Yes"}
                            value={formik.values.auditenddatetype}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="auditenddatetype"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("auditenddatetype", "No")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.auditenddatetype === "No"}
                            value={formik.values.auditenddatetype}
                          />
                          <span>No</span>
                        </div>
                      </div>
                      {formik.touched.auditenddatetype &&
                        formik.errors.auditenddatetype && (
                          <FormFeedback>
                            {formik.errors.auditenddatetype}
                          </FormFeedback>
                        )}
                    </div>
                  </Col>

                  <Col sm="12" className="mt-2">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Duration of Assignment (Days)
                      </Label>
                      <Input
                        type="textarea"
                        name="AssignmentDuration"
                        id="nameVertical"
                        disabled={!isEditable}
                        className="p-3"
                        placeholder="Enter Duration"
                        onChange={formik.handleChange}
                        value={formik.values.AssignmentDuration}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.AssignmentDuration &&
                          !!formik.errors.AssignmentDuration
                        }
                      />
                      {formik.touched.AssignmentDuration &&
                        formik.errors.AssignmentDuration && (
                          <FormFeedback>
                            {formik.errors.AssignmentDuration}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Additional Information</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="2" md="6" xs="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        No. of Positions
                        <span className="mandatory">*</span>
                      </Label>
                      <Input
                        disabled={!isEditable}
                        type="number"
                        name="positions"
                        id="nameVertical"
                        placeholder=""
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.positions}
                      />
                      {formik.touched.positions && formik.errors.positions && (
                        <div className="error text-danger pl-2">
                          {formik.errors.positions}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="4" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">
                        Can this Job be Performed Remotely?
                        <span className="mandatory">*</span>
                      </Label>
                      <div className="d-flex justify-content-center flex-wrap">
                        <div className="mr-5">
                          <Input
                            disabled={!isEditable}
                            type="radio"
                            name="remotework"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("remotework", "Yes")
                            }
                            checked={formik.values.remotework === "Yes"}
                            value={formik.values.remotework}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            disabled={!isEditable}
                            type="radio"
                            name="remotework"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("remotework", "No")
                            }
                            checked={formik.values.remotework === "No"}
                            value={formik.values.remotework}
                          />
                          <span>No</span>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col sm="3" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">Laptop Requirement ?</Label>
                      <div className="d-flex justify-content-center flex-wrap">
                        <div className="mr-5">
                          <Input
                            type="radio"
                            disabled={!isEditable}
                            name="Laptop"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "Yes")
                            }
                            checked={formik.values.Laptop == "Yes"}
                            value={formik.values.Laptop}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="mr-5 ">
                          {" "}
                          <Input
                            type="radio"
                            name="Laptop"
                            disabled={!isEditable}
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "No")
                            }
                            checked={formik.values.Laptop == "No"}
                            value={formik.values.Laptop}
                          />
                          <span>No</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="Laptop"
                            disabled={!isEditable}
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "Peferable")
                            }
                            checked={formik.values.Laptop == "Peferable"}
                            value={formik.values.Laptop}
                          />
                          <span>Preferably</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm="3" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">
                        Vehicle Requirement ?
                      </Label>
                      <div className="d-flex justify-content-center flex-wrap">
                        <div className="mr-5">
                          <Input
                            type="radio"
                            disabled={!isEditable}
                            name="Vehicle"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "Yes")
                            }
                            checked={formik.values.Vehicle == "Yes"}
                            value={formik.values.Vehicle}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="mr-5 ">
                          {" "}
                          <Input
                            type="radio"
                            name="Vehicle"
                            disabled={!isEditable}
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "No")
                            }
                            checked={formik.values.Vehicle == "No"}
                            value={formik.values.Vehicle}
                          />
                          <span>No</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="Vehicle"
                            disabled={!isEditable}
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "Peferable")
                            }
                            checked={formik.values.Vehicle == "Peferable"}
                            value={formik.values.Vehicle}
                          />
                          <span>Preferably</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Job Card Validity</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Opening Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        value={formik.values.openingdate}
                        className={`form-control ${formik.touched.openingdate &&
                          formik.errors.openingdate
                          ? "is-invalid"
                          : ""
                          } ${formik.touched.openingdate &&
                            formik.errors.openingdate
                            ? "invalid-border"
                            : ""
                          }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("openingdate", formik)}
                        name="openingdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "openingdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format(
                              "YYYY-MM-DD"
                            );
                            formik.setFieldValue("openingdate", formattedDate);
                          } else {
                            formik.setFieldValue("openingdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.openingdate &&
                        formik.errors.openingdate && (
                          <div className="error text-danger pl-2">
                            {formik.errors.openingdate}
                          </div>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Closing Date<span className="mandatory">*</span>
                      </Label>
                      <Flatpickr
                        className={`form-control ${formik.touched.closingdate &&
                          formik.errors.closingdate
                          ? "is-invalid"
                          : ""
                          } ${formik.touched.closingdate &&
                            formik.errors.closingdate
                            ? "invalid-border"
                            : ""
                          }`}
                        value={formik.values.closingdate}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate:getCurrentDate()
                          // minDate: new Date().fp_incr(0),
                        }}
                        name="closingdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "closingdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format(
                              "YYYY-MM-DD"
                            );

                            formik.setFieldValue("closingdate", formattedDate);
                          } else {
                            formik.setFieldValue("closingdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />

                      {formik.touched.closingdate &&
                        formik.errors.closingdate && (
                          <div className="error text-danger pl-2">
                            {formik.errors.closingdate}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="4">
                    <div className="text-center">
                      <Label htmlFor="nameVertical">
                        Active Status
                        <span className="mandatory">*</span>
                      </Label>
                      <div className="d-flex justify-content-center">
                        <div className="mr-5">
                          <Input
                            disabled={!isEditable}
                            type="radio"
                            name="status"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("status", "Active")
                            }
                            checked={formik.values.status === "Active"}
                            value={formik.values.status}
                          />
                          <span>Active</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            disabled={!isEditable}
                            type="radio"
                            name="status"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("status", "Inactive")
                            }
                            checked={formik.values.status === "Inactive"}
                            value={formik.values.status}
                          />
                          <span>InActive</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <div className=" text-right ">
            {/* <button
            className="btn btn-dark mr-2"
            onClick={() => history("/publish-job")}
          >
            Cancel
          </button> */}
            {isEditable && (
              <button
                //   className="subsend-btn"
                className="btns"
                onClick={submitHandler}
              >
                Submit
              </button>
            )}
          </div>
        </FormGroup>
      </div>
    </section>
  );
};

export default ViewPublishJob;
